module.exports = {
	sm: 620,
	md: 768,
	lg: 1024,
	xlg: 2048,
};
